import React, { useEffect, useState } from 'react';
import { Button, Collapse } from 'antd';
import './ExpandableOfferCard.css';
import { UpOutlined } from '@ant-design/icons';
import { ReactComponent as OfferTagIcon } from '../../../../assets/Offers/OfferTag.svg';
import { ReactComponent as CheckIcon } from '../../../../assets/Offers/CheckIcon.svg';
import { ReactComponent as ChevronDown } from '../../../../assets/chevronDown.svg';
import { formatDate, hexToRGBA } from '../../../../Utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { setCouponModal, setSuccessModal } from '../../../../slices/OfferSlice';
import TranslateText from '../../../resuableComponents/TranslateText';
import { handlePrintCouponCondition } from '../../../../Utils/paymentUtils';

const { Panel } = Collapse;

const ExpandableOfferCard = ({
    couponCode,
    title,
    baseColor,
    isOfferApplied,
    handleToggleCoupon,
    offerData
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [loader, setLoader] = useState(false);

    const offerApplyLoader = useSelector(state => state.offers.offerApplyLoader);
    const dispatch = useDispatch();

    const toggleExpand = () => setIsExpanded(prev => !prev);

    useEffect(() => {
        if (!offerApplyLoader) {
            setLoader(false);
        }
    }, [offerApplyLoader]);

    const handleClickAction = (code, isActive) => {
        if (!offerApplyLoader) {
            if (!isActive) setLoader(true);

            handleToggleCoupon(code, isActive, () => {
                dispatch(setSuccessModal(true));
                dispatch(setCouponModal(false));
            });
        }
    };



    const couponBackgroundColor = hexToRGBA(baseColor, 0.1);

    return (
        <div className="offerCard" style={{ borderColor: isOfferApplied ? baseColor : undefined }}>
            <div className="offer-header">
                <div className="coupon-code" style={{ background: couponBackgroundColor }}>
                    <OfferTagIcon style={{ color: baseColor }} className="coupon-icon" />
                    <span className="code-text">{couponCode}</span>
                </div>
                {isOfferApplied ? (
                    <span onClick={() => handleClickAction(couponCode, true)} className="removeButton">
                        <TranslateText label={"REMOVE_COUPON"}>
                            Remove
                        </TranslateText>
                    </span>
                ) : (
                    <Button
                        loading={loader}
                        onClick={() => handleClickAction(couponCode, false)}

                        style={{
                            color: baseColor,
                            cursor: offerApplyLoader ? "not-allowed" : "pointer",
                            padding: 0,
                            textTransform: "uppercase"
                        }}
                        className="applyBtn active "
                    >
                        <TranslateText label={"APPLY_COUPON"}>
                            APPLY
                        </TranslateText>
                    </Button>
                )}
            </div>

            <div className="offer-title">{title}</div>

            <Collapse
                ghost
                activeKey={isExpanded ? ['1'] : []}
                onChange={toggleExpand}
                expandIconPosition="end"
                className="offer-collapse"
                expandIcon={({ isActive }) =>
                    isActive ? (
                        <ChevronDown style={{ fontSize: '12px', transform: 'rotate(180deg)', color: "#1890FF" }} />
                    ) : (
                        <ChevronDown style={{ fontSize: '12px', color: "#1890FF" }} />
                    )
                }
            >
                <Panel header={<span className="tnc-link" data-testid="tnc-link"> <TranslateText label={"T_AND_C_TEXT"}> T&C </TranslateText></span>} key="1">
                    <div className="tnc-content" data-testid="tnc-content">
                        {/* <ul>
                            <li>
                                <TranslateText label={"MINIMUM_ORDER_AMOUNT"}> Minimum order amount</TranslateText> {offerData?.criteria?.minMoney?.currencyCode}{' '}
                                {offerData?.criteria?.minMoney?.amount || 0}
                            </li>
                            {offerData?.criteria?.endDate && (
                                <li> <TranslateText label={"OFFER_VALID_TILL"}> Offer valid till </TranslateText> {formatDate(offerData?.criteria?.endDate)}</li>
                            )}
                            {offerData?.criteria?.maxMoney?.amount && (
                                <li> <TranslateText label={"MAXIMUM_DISCOUNT_WORTH"}>Maximum Discount Worth </TranslateText> {offerData?.criteria?.maxMoney?.amount}</li>
                            )}
                            <li><TranslateText label={"APPLICABLE_ON_TEXT"}>Applicable on</TranslateText> {handlePrintCouponCondition(offerData)}</li>
                        </ul> */}
                    </div>
                    {offerData?.terms && (
                        <div
                            className="expanded-details"
                            dangerouslySetInnerHTML={{ __html: offerData.terms }}
                        />
                    )}
                </Panel>
            </Collapse>

            {isOfferApplied && (
                <div className="appliedOffer">
                    <CheckIcon style={{ color: "#1CA672", height: 12 }} />
                    <span><TranslateText label={"OFFER_APPLIED_TEXT"}>OFFER APPLIED </TranslateText></span>
                </div>
            )}
        </div>
    );
};

export default ExpandableOfferCard;
